'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './parking_requirements.routes';

export class ParkingRequirementsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.parking_requirements', [uiRouter])
  .config(routes)
  .component('parkingRequirements', {
    template: require('./parking_requirements.html'),
    controller: ParkingRequirementsComponent,
    controllerAs: 'parkingRequirementsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/parking/parking_requirements/parking_requirements.component.js